<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-6">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><a href="/">Beranda</a></li>
            <li class="breadcrumb-item">
              <a href="/pages/katposisi">Kategori Posisi</a>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              Tambah Posisi Baru
            </li>
          </ol>
        </nav>
      </div>
      <div class="col-6 text-end">
        <router-link to="/pages/katposisi">
          <b-button variant="danger" class="btn btn-add btn-sm mb-2 px-4">
            <i class="fa fa-arrow-left mr-1"></i> &nbsp; Kembali</b-button
          >
        </router-link>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-6">
        <div class="card">
          <div class="card-header pb-0">
            <h6><b>Data Kategori</b></h6>
          </div>
          <hr />
          <div class="card-body">
            <form class="row g-3 needs-validation" novalidate="">
              <div class="col-md-12 position-relative">
                <b for="validationTooltip01">Nama Posisi</b>
                <input
                  type="text"
                  class="form-control"
                  @change="validationForm"
                  v-bind:class="
                    formSubmitted
                      ? nama_posisiError
                        ? 'is-invalid'
                        : 'is-valid'
                      : ''
                  "
                  id="nama_posisi"
                  placeholder="Nama Posisi"
                  v-model="nama_posisi"
                />
                <small
                  class="align-end text-danger"
                  v-if="errors[0] && formSubmitted"
                >
                  {{ errors[0].message }}
                </small>
              </div>
              <div class="col-md-12 position-relative">
                <b for="validationTooltip02">Tipe Posisi</b>
                <select
                  name="tipe"
                  id="tipe"
                  placeholder="Tipe Posisi"
                  v-model="tipe_posisi"
                  class="form-control"
                  v-bind:class="
                    formSubmitted
                      ? tipe_posisiError
                        ? 'is-invalid'
                        : 'is-valid'
                      : ''
                  "
                >
                  <option value="pemain">Pemain</option>
                  <option value="ofisial">Ofisial</option>
                </select>

                <small class="text-danger" v-if="errors[1] && formSubmitted">
                  {{ errors[1].message }}
                </small>
              </div>

              <div class="col-12 text-end">
                <button class="btn btn-light" @click="resetForm" type="button">
                  Reset
                </button>
                &nbsp;
                <button
                  class="btn btn-primary"
                  @click="simpanPosisi"
                  type="button"
                >
                  <span v-if="loading">
                    <div class="spinner-border spinner-border-sm">
                      <span class="sr-only"></span>
                    </div>
                    Loading ..
                  </span>
                  <span v-else> Simpan </span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import KategoriService from "@/_services/kategori.service";
import Swal from "sweetalert2";
import CKEditor from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import DropZone from "dropzone-vue";

export default {
  components: {
    ckeditor: CKEditor.component,
    DropZone,
  },
  data() {
    return {
      id: this.$route.query.idk,
      urlImage: process.env.VUE_APP_API_URL_IMAGE,
      loading: false,
      errors: [],
      formSubmitted: false,
      nama_posisi: "",
      nama_posisiError: false,
      tipe_posisi: "",
      tipe_posisiError: false,
      validation: false,
      editor: ClassicEditor,
    };
  },
  mounted() {
    this.detailDetail();
  },
  methods: {
    detailDetail() {
      this.loading = true;
      KategoriService.getPosDetail(this.id)
        .then((response) => {
          // console.log("data", response.data.data);
          const val = response.data.data;
          this.previewUrl = this.urlImage + val.images;
          this.nama_skuad = val.nama_skuad;
          this.staf_pelatih = val.staf_pelatih;
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },

    validationForm() {
      this.errors = [];
      if (this.nama_posisi.length < 1) {
        this.nama_posisiError = true;
        this.errors.push({
          message: "Nama posisi harus di isi !",
        });
      } else {
        this.nama_posisiError = false;
        this.errors.push({
          message: "",
        });
      }
      if (this.tipe_posisi.length < 1) {
        this.tipe_posisiError = true;
        this.errors.push({
          message: "Kategori posisi harus di isi !",
        });
      } else {
        this.tipe_posisiError = false;
        this.errors.push({
          message: "",
        });
      }
    },

    simpanPosisi() {
      this.formSubmitted = true;
      this.validationForm();

      if (this.nama_posisi && this.tipe_posisi) {
        this.validation = true;
        this.loading = true;

        const data = {
          nama_posisi: this.nama_posisi,
          tipe: this.tipe_posisi,
        };
        KategoriService.addPosisi(data)
          .then((response) => {
            // console.log("berhasil", response.data);
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Data Berhasil Ditambah",
              showConfirmButton: false,
              timer: 1500,
            });
            this.loading = false;
            this.$router.push("/pages/katposisi");
          })
          .catch((err) => {
            console.log(err);
            this.loading = false;
            Swal.fire({
              position: "top-end",
              icon: "error",
              title: "Data Gagal Ditambah",
              showConfirmButton: false,
              timer: 1500,
            });
          });
      }
    },

    resetForm() {
      // console.log("rseset ");
      this.loading = false;
      this.errors = [];
      this.formSubmitted = false;
      this.nama_posisi = "";
      this.nama_posisiError = false;
      this.tipe_posisi = "";
      this.tipe_posisiError = false;
      this.validation = false;
    },
  },
};
</script>

<style scoped>
@import "dropzone-vue/dist/dropzone-vue.common.css";
.customize-table {
  --easy-table-header-font-size: 14px;
  --easy-table-header-height: 40px;
  --easy-table-body-row-height: 40px;
  --easy-table-body-row-font-size: 14px;
}

.searchBar {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
}

#searchQueryInput {
  width: 100%;
  height: 2.4rem;
  background: #f5f5f5;
  outline: none;
  border: none;
  border-radius: 1.625rem;
  padding: 0 3.5rem 0 1.5rem;
  font-size: 1rem;
}

#searchQuerySubmit {
  width: 3.5rem;
  height: 2.8rem;
  margin-left: -3.5rem;
  background: none;
  border: none;
  outline: none;
}

#searchQuerySubmit:hover {
  cursor: pointer;
}

.font-large-2 {
  font-size: 3rem !important;
}

.count {
  background: rgb(149, 2, 13);
  background: radial-gradient(
    circle,
    rgba(149, 2, 13, 1) 0%,
    rgba(216, 49, 61, 1) 100%
  );
}

.form-control {
  border: #a8a7a7 1.4px solid;
}

.form-control:focus {
  border: #a8a7a7 1.7px solid;
}
</style>
